export default __webpack_public_path__ + "static/media/Avalanche Band.11b05257.jpg";